<script>
  import checkPasswordStrength from "check-password-strength";
  import { authStore } from "../../stores/General";
  import Form from "../../components/form/Form.svelte";
  import Icon, { Save, Eye, EyeOff } from "svelte-hero-icons";
  import PlainInput from "../form/PlainInput.svelte";
  import InputWrapper from "../form/InputWrapper.svelte";
  import { updatePassword } from "../../utils/auth";
  const { user } = authStore;

  let myCustomOptions = [
    {
      id: 0,
      value: "Too weak",
      minDiversity: 0,
      minLength: 0,
    },
    {
      id: 1,
      value: "Weak",
      minDiversity: 2,
      minLength: 6,
    },
    {
      id: 2,
      value: "Medium",
      minDiversity: 3,
      minLength: 8,
    },
    {
      id: 3,
      value: "Strong",
      minDiversity: 4,
      minLength: 10,
    },
  ];

  let authType = $user?.auth_type?.split("|")[0] || "auth0";
  let form;
  let rules;
  let oldPasswordView = false;
  let newPasswordView = false;
  let inputDetail = {};
  let oldPass = "";
  let newPass = "";
  let confirmNewPass = "";

  if (newPass.length > 0) {
  }

  $: passmatch = "";
  $: oldpassmatch = "";
  $: strength = checkPasswordStrength.passwordStrength(
    newPass,
    myCustomOptions
  );
  $: strength1 = checkPasswordStrength.passwordStrength(
    oldPass,
    myCustomOptions
  );

  function onOldPassChange(event) {
    oldPass = event.detail.target.value;
    if (oldPass) {
      if (newPass !== oldPass) {
        oldpassmatch = false;
      } else {
        oldpassmatch = true;
      }
      oldPass = oldPass;
    }
  }

  function onNewPassChange(event) {
    newPass = event.detail.target.value;
    if (newPass) {
      if (newPass !== oldPass) {
        oldpassmatch = false;
      } else {
        oldpassmatch = true;
      }
      if (newPass !== confirmNewPass) {
        passmatch = false;
      } else {
        passmatch = true;
      }
      newPass = newPass;
    }
  }

  function onConfirmNewPassChange(event) {
    confirmNewPass = event.detail.target.value;
    if (confirmNewPass) {
      if (newPass !== confirmNewPass) {
        passmatch = false;
      } else {
        passmatch = true;
      }
      confirmNewPass = confirmNewPass;
    }
  }

  function onSubmit(e) {
    const data = { oldPass, newPass, confirmNewPass };
    updatePassword(data);
    oldPass = "";
    newPass = "";
    confirmNewPass = "";
  }
</script>

<div class="flex">
  <div class="w-full">
    <div class="mt-4">
      <Form {rules} on:submit={onSubmit} bind:this={form}>
        <div
          class="lg:mx-auto justify-center grid grid-cols-1 gap-4 lg:w-[80%]"
        >
          <InputWrapper label="Old Password">
            <PlainInput
              type={oldPasswordView ? "text" : "password"}
              name="oldPass"
              value={oldPass}
              on:change={onOldPassChange}
            />
            <div
              on:click={() => {
                oldPasswordView = !oldPasswordView;
              }}
            >
              <Icon
                src={oldPasswordView ? Eye : EyeOff}
                class="mr-2.5 h-5 w-5 absolute right-0 top-10 cursor-pointer"
                solid
              />
            </div>
          </InputWrapper>
          <InputWrapper label="New Password">
            <PlainInput
              type={newPasswordView ? "text" : "password"}
              name="newPass"
              value={newPass}
              on:change={onNewPassChange}
            />
            <div
              on:click={() => {
                newPasswordView = !newPasswordView;
              }}
            >
              <Icon
                src={newPasswordView ? Eye : EyeOff}
                class="mr-2.5 h-5 w-5 absolute right-0 top-10 cursor-pointer"
                solid
              />
            </div>
          </InputWrapper>

          {#if (newPass.length > 0 && strength.value === "Too weak") || strength.value === "Weak"}
            <p style="color: red; font-size:small; margin-top: -12px; ">
              Your password is {strength.value.toLowerCase()}
            </p>
          {:else if oldpassmatch === true}
            <p style="color: red; font-size:small; margin-top: -10px; ">
              Old and new password must not be same.
            </p>
          {/if}

          <InputWrapper label="Retype New Password">
            <PlainInput
              type={newPasswordView ? "text" : "password"}
              name="confirmNewPass"
              value={confirmNewPass}
              on:change={onConfirmNewPassChange}
            />
          </InputWrapper>
          {#if confirmNewPass.length > 0 && passmatch === false}
            <p style="color: red; font-size:small; margin-top: -10px; ">
              Your password does not match.
            </p>
          {/if}
        </div>
        <div class="my-4 lg:mx-auto mt-20 flex lg:w-[80%]">
          {#if authType === "auth0"}
            <button
              type="submit"
              disabled={oldpassmatch === true ||
                oldpassmatch === "" ||
                passmatch === false ||
                passmatch === "" ||
                newPass.length == 0 ||
                confirmNewPass.length == 0 ||
                strength.value === "Too weak" ||
                strength.value === "Weak" ||
                oldPass.length == 0 ||
                strength1.value === "Too weak" ||
                (strength1.value === "Weak" && true)}
              class={`w-80 h-12 mb-2 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv ${
                oldpassmatch === true ||
                oldpassmatch === "" ||
                passmatch === false ||
                passmatch === "" ||
                newPass.length == 0 ||
                confirmNewPass.length == 0 ||
                strength.value === "Too weak" ||
                strength.value === "Weak" ||
                oldPass.length == 0 ||
                strength1.value === "Too weak" ||
                strength1.value === "Weak"
                  ? "border-gray-400 bg-gray-400"
                  : "border-custom-orange bg-custom-orange hover:bg-custom-orange"
              }  text-sm font-medium text-white  focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600`}
            >
              <Icon src={Save} class="mr-2.5 h-5 w-5 text-white" solid />
              <span class="text-white">Save</span>
            </button>
            <button
              type="button"
              class="w-40 h-12 ml-10 mb-2 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange text-sm font-medium text-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
            >
              <span>Cancel</span>
            </button>
          {/if}
        </div>
      </Form>
    </div>
  </div>
</div>
